import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { formatMoney } from "../lib/loanForm";

export const LoanAmountFields = ({ calculations, form, ids, isInvalid, onChange }) => {
  const fields = [
    ["loan_amount", "Loan Amount (RM) *", "amount", "amountTestId"],
    ["interest_amount", "Interest (RM) *", "interest", "interestTestId"],
    ["deposit_amount", "Deposit (RM) *", "deposit", "depositTestId"],
    ["stamp_duty", "Stamp Duty (RM) *", "stampDuty", "stampDutyTestId"],
  ];

  return (
    <>
      <div className="borrow-loan-grid">
        {fields.map(([field, label, idKey, testIdKey]) => (
          <div key={field}>
            <Label htmlFor={ids[idKey]}>{label}</Label>
            <Input
              id={ids[idKey]}
              data-testid={ids[testIdKey]}
              className={isInvalid(field) ? "borrow-loan-field-error" : ""}
              type="number"
              min="0"
              value={form[field]}
              onChange={(event) => onChange(field, event.target.value)}
            />
          </div>
        ))}
      </div>
      <div className="borrow-calculation-row">
        <div data-testid={ids.cashOnHandTestId}>
          <span>Cash On Hand</span>
          <strong>{formatMoney(calculations.cashOnHand)}</strong>
        </div>
        <div data-testid={ids.outstandingTestId}>
          <span>Outstanding Balance</span>
          <strong>{formatMoney(calculations.outstanding)}</strong>
        </div>
      </div>
      <div className="borrow-loan-grid">
        <div>
          <Label htmlFor={ids.loanDate}>Loan Date *</Label>
          <Input
            id={ids.loanDate}
            data-testid={ids.loanDateTestId}
            className={isInvalid("loan_date") ? "borrow-loan-field-error" : ""}
            type="date"
            value={form.loan_date}
            onChange={(event) => onChange("loan_date", event.target.value)}
          />
        </div>
        <div>
          <Label htmlFor={ids.termDays}>Terms (Days) *</Label>
          <Input
            id={ids.termDays}
            data-testid={ids.termDaysTestId}
            className={isInvalid("term_days") ? "borrow-loan-field-error" : ""}
            type="number"
            min="1"
            value={form.term_days}
            onChange={(event) => onChange("term_days", event.target.value)}
          />
        </div>
      </div>
      <div>
        <Label htmlFor={ids.dueDate}>{ids.dueDateLabel}</Label>
        <Input
          id={ids.dueDate}
          data-testid={ids.dueDateTestId}
          value={calculations.dueDate}
          readOnly
        />
      </div>
      <div>
        <Label htmlFor={ids.remarks}>Remarks / Term *</Label>
        <Textarea
          id={ids.remarks}
          data-testid={ids.remarksTestId}
          className={isInvalid("remarks") ? "borrow-loan-field-error" : ""}
          value={form.remarks}
          onChange={(event) => onChange("remarks", event.target.value)}
          placeholder="Enter remarks or term details..."
        />
      </div>
    </>
  );
};